import { Environment } from 'environments/environment.model';
import { pouchConfig_prod } from 'configs/pouch-config.prod';
import { firebaseConfig_prod } from 'configs/firebase-config.prod';
import { mixPanelConfig_prod } from 'configs/mixpanel-config.prod';
import { elasticConfig_prod } from 'configs/elastic-config.prod';

export const AppEnvironment: Environment = {
  name: 'prod',
  isAngularProduction: true,
  pouchConfig: pouchConfig_prod,
  firebaseConfig: firebaseConfig_prod,
  mixPanelConfig: mixPanelConfig_prod,
  sendsTelemetry: true,
  elasticConfig: elasticConfig_prod,
  storageBucket: 'images.mh-physique.app',
  googlePlayProductId: 'mhphysique',
  appleProductIds: ['mhphysique_monthly', 'mhphysique_yearly'],
}
